import { GISStatusBase } from './base/g-i-s-status-base';

export class GISStatus extends GISStatusBase { }